import React, { Component } from 'react';
import Text from '../../../components_new/common/Text';
import ProfileImg from '../../../components_new/common/ProfileImg';
import Description from './Description';
import Reviews from './Reviews';
import Request from './Request';
import styled from 'styled-components';
import { Flex, Box } from 'rebass';
import _ from 'lodash';
import moment from 'moment';
import GoogleMapLoader from 'react-google-maps-loader';
import CardList from '../../../components_new/CardList';
import { Whitespace } from '../../../components_new/common';
import { googleMapAPI } from '../../../config';
import { shadows } from '../../../tailwind';
import { buildAvatarPath } from '../../../helpers/photoutils';
import Link from '../../../components/Link';
import ReportModal from './ReportModal';
import Modal from '../../../components_new/Modal';
import { trackContactHost, trackBooking } from '../../../core/analytics';

const CardBox = styled(Box)`
  background-color: #ffffff;
  box-shadow: ${shadows.default};
  height: auto;
  min-width: ${props => props.width}px;
  max-width: ${props => props.width}px;
  margin-bottom: 24px;
`;

class Details extends Component {
  constructor(props) {
    super(props);
    this.state = {
      focusedImage: props.focusedImage,
      hostId: 0,
      listId: 0,
      price: 0,
      focusedIndex: 0,
      reporting: false,
    };
  }
  componentDidMount() {
    this.setState({ loaded: true });
    const { category } = this.props;
  }

  componentDidUpdate(prevProps) {
    const newState = {};

    if (prevProps.focusedImage !== this.props.focusedImage) {
      this.setState({
        focusedImage: this.props.focusedImage,
      });
    }

    const { listId, price } = this.props;
    const hostId = this.props.user.id;

    // const submit = createSubmit(listId, hostId, price);
    const submit = () => {
      const { startDate, endDate, bookingProcess, units } = this.props;
      trackBooking(listId);
      bookingProcess(listId, 0, startDate, endDate, false, units);
    };

    if (
      hostId !== this.state.hostId ||
      listId !== this.state.listId ||
      price !== this.state.price
    ) {
      this.setState({ submitHandler: submit, listId, hostId, price });
    }
  }

  onReport = () => {
    this.setState({
      reporting: true,
    });
  };
  closeReport = () => {
    this.setState({
      reporting: false,
    });
  };

  /*
listId
hostId
guestId - optional
checkIn
checkOut
basePrice
currency - hard code to USD
tota
updatedAt
*/

  updateMainImg = (img, i, direction) => {
    if (img) {
      this.setState({
        focusedImage: img,
        focusedIndex: i,
      });
    } else if (i) {
      this.setState({
        focusedImage: this.props.images[i],
        focusedIndex: i,
      });
    } else if (direction === 'right') {
      if (this.state.focusedIndex < this.props.images.length - 1) {
        const nextIdx = ++this.state.focusedIndex;
        this.setState({
          focusedImage: this.props.images[nextIdx],
          focusedIndex: nextIdx,
        });
      }
    } else if (direction === 'left') {
      if (this.state.focusedIndex > 0) {
        const nextIdx = --this.state.focusedIndex;
        this.setState({
          focusedImage: this.props.images[nextIdx],
          focusedIndex: nextIdx,
        });
      }
    }
  };
  contact = () => {
    trackContactHost(this.state.price, this.state.category);
    this.props.contactHostOpen(this.props.id);
  };
  renderOwnerInfo = () => {
    const {
      contactHostOpen,
      user: {
        profile: { profileId },
      },
      isHost,
      preview,
    } = this.props;

    return (
      <Flex p={4}>
        <Link to={`/users/show/${profileId}`}>
          <ProfileImg
            backgroundImg={
              (this.props.user.profile.picture &&
                buildAvatarPath(this.props.user.profile.picture)) ||
              '/icons/avatar.svg'
            }
            large
          />
        </Link>
        <Flex flexDirection="column" justifyContent="center" ml={4}>
          <Link to={`/users/show/${profileId}`}>
            <Text emphasis grayDark clickable p={1}>
              {this.props.user.profile.displayName}
            </Text>
          </Link>
          <Text p={1}>Member since {this.props.user.profile.yearJoined}</Text>
          <Link to={`/users/show/${profileId}`}>
            <Text link clickable p={1}>
              View profile
            </Text>
          </Link>
        </Flex>
      </Flex>
    );
  };

  render() {
    const ownersOtherItems =
      this.props.ownersItems &&
      this.props.ownersItems.map((e, i) => ({
        coverPhoto: e.coverPhoto,
        title: e.title,
        location: e.location,
        basePrice: e.price,
        reviewsCount: e.reviewsCount,
        reviewsStarRating: e.reviewsStarRating,
        id: e.id,
        key: e.id,
      }));

    const otherInterests =
      this.props.otherInterests &&
      this.props.otherInterests.map((e, i) => ({
        coverPhoto: e.coverPhoto,
        title: e.title,
        location: e.location,
        basePrice: e.price,
        reviewsCount: e.reviewsCount,
        reviewsStarRating: e.reviewsStarRating,
        id: e.id,
        key: e.id,
      }));

    const MapRender = this.props.Map
      ? this.props.Map
      : () => <div>Map Placeholder</div>;

    const { preview, blockedDates, isHost, listId } = this.props;

    return (
      <GoogleMapLoader
        params={{
          libraries: 'places',
          region: 'US',
          language: 'en',
          key: googleMapAPI,
        }}
        render={googleMaps =>
          googleMaps && (
            <Flex
              justifyContent="flex-start"
              alignItems="center"
              flexDirection="column"
              mx={40}
              pt={24}
              id="details-container"
            >
              <Flex
                flex={1}
                flexDirection="row"
                justifyContent="flex-start"
                alignItems="stretch"
                style={{ maxWidth: preview ? '850px' : '1600px' }}
              >
                <Box flex={2}>
                  <CardBox>
                    <Description
                      updateMainImg={this.updateMainImg}
                      images={this.props.images}
                      focusedImage={this.state.focusedImage}
                      focusedIndex={this.state.focusedIndex}
                      description={this.props.description}
                      rentalConditions={this.props.rentalConditions}
                      title={this.props.title}
                      location={this.props.location}
                      preview={preview}
                      onReport={this.onReport}
                    />
                  </CardBox>

                  <OwnerSmall>{this.renderOwnerInfo()}</OwnerSmall>
                  <CardBox>
                    <Reviews
                      averageRating={this.props.averageRating}
                      reviews={this.props.reviews}
                      reviewsCount={this.props.reviewsCount}
                    />
                  </CardBox>
                </Box>
                <Box ml={24}>
                  <CardBox width={344} py={24} px={24}>
                    <Request
                      averageRating={this.props.averageRating}
                      reviewsCount={this.props.reviewsCount}
                      price={this.props.price}
                      onSubmit={this.state.submitHandler}
                      preview={preview}
                      blockedDates={_.map(blockedDates, d =>
                        moment(d.blockedDates),
                      )}
                      isHost={isHost}
                      listId={listId}
                      contact={this.contact}
                    />
                  </CardBox>
                  <OwnerLarge>{this.renderOwnerInfo()}</OwnerLarge>
                  <CardBox
                    style={{ maxHeight: '357px', minHeight: '375px' }}
                    width={344}
                  >
                    {MapRender()}
                  </CardBox>
                </Box>
              </Flex>
              <Box flex={1} mb={64} mb={64}>
                <Whitespace />
                {otherInterests && otherInterests.length > 0 && (
                  <div m={24}>
                    <Text sectionheader mb={4} pl="12px">
                      Items like this one
                    </Text>
                    <CardList items={otherInterests} fixedWidth={1000} />
                    <Whitespace small />
                  </div>
                )}
              </Box>
              <Modal isOpen={this.state.reporting} maxWidth={450}>
                <ReportModal
                  listId={this.props.listId}
                  close={this.closeReport}
                />
              </Modal>
            </Flex>
          )
        }
      />
    );
  }
}

export default Details;

const OwnerSmall = styled(CardBox)`
  display: block;

  @media screen and (min-width: 1200px) {
    display: none;
  }
`;

const OwnerLarge = styled(CardBox)`
  display: none;

  @media screen and (min-width: 1200px) {
    display: block;
  }
`;



// WEBPACK FOOTER //
// ./src/routes/presentation/Details/Details.js